import React from 'react'
import Link from 'next/link'
import { Divider, Typography, Row, Col } from 'antd'
import EmailLogin from 'components/auth/EmailLogin'
import SocialLink from 'components/auth/SocialLink'
import { Base_QueryDocument } from 'graphql/generated/types'
import ApplicationLayout from 'layouts/application'
import { initializeApollo, addApolloState } from 'util/apolloClient'

const { Title, Paragraph } = Typography

const renderLink = () => {
  return (
    <div>
      <Link href="/auth/forgot-password">Forgot Password</Link>
      &nbsp;or&nbsp;
      <Link href="/auth/register">Register</Link>
    </div>
  )
}

const AuthPage = (props) => {
  const divStyle = { marginTop: '32px' }
  const { data: pageData } = props

  const {
    all_brokers: { data: allBrokers },
    nav_calculators: { data: navCalculators },
    all_pages: { data: allPages },
  } = pageData

  return (
    <ApplicationLayout
      allBrokers={allBrokers}
      navCalculators={navCalculators}
      allPages={allPages}
    >
      <Row className="authPage">
        <Col span="24">
          <Title level={2}>Login to your Account.</Title>
          <Paragraph>Please enter your details to login.</Paragraph>
        </Col>
        <Row className="formContainer" style={divStyle}>
          <Col span="24">
            <Row className="row">
              <Col span="24">
                <SocialLink />
                <Divider>or</Divider>
                <EmailLogin />
              </Col>
            </Row>
            <div className="linkContainer">{renderLink()}</div>
          </Col>
        </Row>
      </Row>
    </ApplicationLayout>
  )
}

export async function getStaticProps() {
  const apolloClient = initializeApollo()

  const queryResults = await apolloClient.query({
    query: Base_QueryDocument,
  })
  const { data } = queryResults

  return addApolloState(apolloClient, { props: { data } })
}

export default AuthPage
